export const FETCH_TRAVEL_APPROVAL_CONFIGS = 'FETCH_TRAVEL_APPROVAL_CONFIGS'
export const UPDATE_TRAVEL_APPROVAL_CONFIG = 'UPDATE_TRAVEL_APPROVAL_CONFIG'
export const SET_TRAVEL_APPROVAL_CONFIGS = 'SET_TRAVEL_APPROVAL_CONFIGS'